/*
 * @Date: 2020-07-08 10:22:38
 * @LastEditTime: 2021-11-23 14:19:02
 */
import * as React from 'react'
import * as Styles from './HomeChoiceness.style'
import {classes} from 'typestyle'
import {ImageView} from '../ImageView/ImageView'
import {deletePictureParams} from '../../../../utils/tools'
import { ViewingMonitor, reAssemblyUbt, reportClickEvent } from '@weike/operation-report'

export function HomeChoiceness(props) {
    const HomeChoicenessEl = React.useRef(null)
    const content = props.data.contents
    const { id, name , invite_id} = props.data

    React.useEffect(() => {
        if (window.location.search.indexOf('pos=gkk') > -1) {
           window.onload = () => {
                window.scrollTo(0, HomeChoicenessEl.current.getBoundingClientRect().top - 50)
            }
        }
    }, [])

    const linkto = (item, index) => {
        reportClickEvent(`feed__${props.data.id}`, {
            index,
            url: item.link,
            inviter_id: invite_id,
            context: name
        })
        setTimeout(() => {
            location.assign(item.link)
        }, 150)
    }

    if (content.length > 0) {
        return (
            <div className={Styles.HomeChoiceness}>
                {content.map((item, index) => (
                <ViewingMonitor
                    key={index}
                    ubt={reAssemblyUbt(`feed__${props.data.id}`)}
                    params={{
                        index,
                        url: item.link,
                        inviter_id: invite_id,
                        context: name
                    }}
                >
                    <div className={Styles.HomeChoicenessWrap} ref={HomeChoicenessEl} key={item.content_id} onClick={() => linkto(item, index)}>
                        <div className={Styles.leftModule}>
                            <div className={Styles.bigTitle}>
                                <ImageView url={item.title_cover_url} width={300}/>
                            </div>
                            <div className={Styles.subTitle}>
                                {item.title}
                            </div>
                            <div className={classes(Styles.content, 'TextChangeToTwoLines')}>
                                {item.sub_title}
                            </div>
                        </div>
                        <div className={Styles.rightModule}>
                            <div className={Styles.cover} >
                                <div>
                                    <ImageView url={item.cover_url} width={300}/>
                                </div>
                                {/* <span/> */}
                                <img className={Styles.playBtn} src="https://static-1253442168.image.myqcloud.com/picture/12209467_3af8357bb456c28c44d02553318ba349.jpg" alt=""/>
                             </div>
                        </div>
                    </div>
                </ViewingMonitor>
                ))}
            </div>
        )
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeChoiceness/HomeChoiceness.tsx